<template>
  <div class="modal-dialog__header modal-header">
    <div class="modal-header__titles">
      <div class="modal-header__title">{{ title }}</div>
      <div class="modal-header__subtitle">{{ subtitle }}</div>
      <hr v-if="(title || subtitle) && !isMobile">
    </div>

    <button @click="$emit('close')" class="modal-dialog--close figure figure--cross" />
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import MediaDetector from '@/utils/MediaDetector'

@Component({
  mixins: [
    MediaDetector,
  ],
  props: {
    title: {
      type: String,
      required: false,
    },
    subtitle: {
      type: String,
      required: false,
    },
  },
})
export default class Header extends Vue {

}
</script>

<style lang="scss">
.modal-dialog__header {
  display: flex;
  margin-bottom: 15px;
  padding: 0;
  border: 0;
}
.modal-header__titles {
  flex: 1 0 auto;

  hr {
    display: inline-block;
    vertical-align: middle;
    width: 40px;
    margin: 0;
    border-bottom: 5px solid #fff;
  }
}
.modal-header__title {
  font-size: 2.2rem;
  color: #fff;
  text-transform: uppercase;
}
.modal-header__subtitle {
  font-size: 1.4rem;
  color: #fff;
  text-transform: uppercase;
}
.modal-dialog--close {
  border: 0;
  background: transparent;
  color: #fff;
  font-size: 16px;
  padding: 0;
  outline: none;
  
  @media screen and (min-width: 1350px) {
    margin: -3px -27px 3px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modal/Header.vue